import { CounterDirectiveModule } from '@b2b/common/directives/counter';
import { EmailOptionsDirectiveModule } from '@b2b/common/directives/emailOptions';
import { ReservationInputDirectiveModule } from '@b2b/common/directives/reservationInput';
import { SimpleFormInputDirectiveModule } from '@b2b/common/directives/simpleFormInput';
import { LoadACMECheckoutResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { IInjectable, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersCheckoutControllerModule } from './controllers/OrdersCheckoutController';

function EventDataResolver(): IInjectable {
  return [
    '$stateParams',
    'ApiService',
    function ($stateParams, ApiService) {
      if ($stateParams.accountId && $stateParams.id) {
        return ApiService.partners.reseller.event({
          accountId: $stateParams.accountId,
          eventId: $stateParams.id,
        });
      }

      if ($stateParams.id) {
        return ApiService.program.instances.detail($stateParams.id);
      }

      return { data: { success: false } };
    },
  ];
}

export const OrdersCheckoutView = angular
  .module('acme.view.application.orders.checkout', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    CounterDirectiveModule,
    EmailOptionsDirectiveModule,
    ReservationInputDirectiveModule,
    SimpleFormInputDirectiveModule,
    OrdersCheckoutControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.orders.checkout',
      url: '/checkout/:id?customerId&accountId&accountContactId&orderRequestItemIds',
      params: {
        id: null,
      },
      views: {
        'subview-main': {
          controller: 'OrdersCheckoutController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/checkout/checkout.tpl.html',
        },
      },
      data: {
        pageTitle: 'Complete Order',
      },
      resolve: {
        EventData: EventDataResolver(),
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
      },
    });
  }).name;
